import gql from 'graphql-tag';

export const UPDATE_PUSH_NOTIFICATION_TOKEN = gql`
  mutation UpdatePushNotificationToken($dispensaryId: String!, $token: String!) {
    updatePushNotificationToken(dispensaryId: $dispensaryId, token: $token) {
      success
    }
  }
`;
